import { LoadingButton } from "@mui/lab";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { useForm, type SubmitHandler } from "react-hook-form";
import { useApiMutation } from "src/hooks/useApiMutation";
import { toast } from "src/Toaster/Toaster";
import type { IFairCreation } from "./type/fairType";

interface Props {
	name?: string;
	id: number | string;
}

export default function DeleteFair({ id, name = "CONFIRM" }: Props) {
	const { register, handleSubmit } =
		useForm<Pick<IFairCreation, "fair_name">>();

	const { mutate: deleteFair, isPending } = useApiMutation<void, void>({
		method: "DELETE",
		endPoint: `/api/fair/${id}`,
		invalidateQueries: ["Fairs"],
	});

	const handleDeleteFair: SubmitHandler<Pick<IFairCreation, "fair_name">> = ({
		fair_name,
	}) => {
		if (fair_name !== name) {
			return toast.fire({
				icon: "error",
				title: "Your input and fair name did not match!",
				position: "top",
			});
		}

		deleteFair();
	};

	return (
		<Box component="form" onSubmit={handleSubmit(handleDeleteFair)}>
			<Typography textAlign={"center"} mt={2} variant="h4" component="h4">
				Please type{" "}
				<Typography variant="h4" component="span" color="red">
					{name}
				</Typography>{" "}
				to confirm delete!
			</Typography>
			<Grid container sx={{ mt: "24px" }}>
				<Grid item xs={12} sm={12}>
					<TextField
						fullWidth
						type="text"
						label="Confirm Delete"
						{...register("fair_name", {
							required: {
								value: true,
								message: "Please, Provide a fair name!",
							},
						})}
					/>
				</Grid>
			</Grid>
			{!isPending ? (
				<Button
					type="submit"
					fullWidth
					variant="contained"
					disableElevation
					sx={{
						mt: 3,
						mb: 2,
						py: 1,
					}}
				>
					Delete
				</Button>
			) : (
				<LoadingButton
					loading
					loadingIndicator="Updating..."
					fullWidth
					variant="outlined"
					disabled
					sx={{
						mt: 3,
						mb: 2,
						py: 1,
					}}
				>
					<span>Deleting...</span>
				</LoadingButton>
			)}
		</Box>
	);
}
